// extracted by mini-css-extract-plugin
export default {"compareIcon":"_2WL4j","headerContainer":"O6hkc","carsCountBubble":"_12DH3","headerTooltip":"_29CmT","itemCardTooltip":"_2bCiZ"};